<template>
    <div class="container-fluid">
        <Loader v-if="loading"/>
        <div class="row" v-else>
            <template v-if="data.length">
                <div
                    v-for="(camp, i) in data"
                    :key="i"
                    class="col-xl-3 col-lg-4 col-6">
                        <Card 
                            v-if="$route.params.campaignType === 'favorite'"
                            @favorite="onFavorite"
                            :card="camp"
                            class="mb-3"
                            :id="`favorite-cards-${i}`"/>
                        <CampaignCard 
                            v-else
                            @archive="onArchive"
                            @restore="onRestore"
                            :loading = "archivingCampaign === camp.id" 
                            :data="camp"
                            :id="`campaign-card-${i}`"/>    
                </div>
            </template>
            <EmptyStateCampaigns
                v-else 
                :stateIcon="$route.params.campaignType"/>
        </div>
       
    </div>
</template>

<script>
import store from '../../store'
import  useCampaigns  from '../../core/hooks/dashboard/useCampaigns'
import { useRouter } from '../../core/hooks'
import { computed, onMounted, reactive, ref, watch } from '@vue/composition-api'
import CampaignCard from './components/CampaignCard'
import EmptyStateCampaigns from './components/EmptyStateCampaigns'
import Icon from '@/components/Theme/Icon'
import Card from '@/components/Card'
import { Loader } from '@/components/Icons'
export default {
    name: 'CampaignList',
    components: {
        CampaignCard,
        Card,
        Loader,
        Icon,
        EmptyStateCampaigns
    },
    props: {
        currentTab: String
    },
    setup: function(props, context) {
        const loading = ref(true)
        const userId = store.state.user.uid
        const archivingCampaign = ref(null)
        const {route} = useRouter()
        const {data, getData, archiveData, restoreCampaign, favoriteCampaigns} = useCampaigns()

        const onArchive = async (campData) => {
            archivingCampaign.value = campData.id
            const archived = await archiveData(campData)    
            archivingCampaign.value = null 
            context.root.$sendMixpanelEvent('Archive Campaign Clicked', {
                'Campaign Name': campData.title,
                Archived: !!archived
            })

            context.root.$ga.event('Campaign', 'Archive Campaign Click', `
                Campaign: ${campData.title},
                Archived: ${!!archived}
            `)
        }
        const onRestore = (campData) => {
            restoreCampaign(campData) 
            context.root.$sendMixpanelEvent('Archive Restore Clicked', {
                'Campaign Name': campData.title
            })    
            context.root.$ga.event('Campaign', 'Archive Restore Click', 'Campaign', campData.title)  
        }
        const onFavorite = (campData) => {
            favoriteCampaigns(campData, userId)
        }

        watch(route, (route) => {
            loading.value = true
            getData(route.params.campaignType, userId)
                .finally(()=> {
                    loading.value = false
                })
        }, {immediate: true})

        return {
            loading,
            data,
            onArchive,
            onRestore,
            onFavorite,
            archivingCampaign
        }
    }
}
</script>

<style>

</style>